import clsx from 'clsx';
import { useCountdown } from 'hooks/draw/useCountdown';
import styles from './DrawCounter.module.css';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface DrawCounterProps {
  targetDate: Date;
  /** Whether the component should provide any margins or paddings */
  bare?: boolean;
  /** The text to show above the counter. The default text will be for nullish
   * values. You can provide empty-string to show no text
   */
  introText?: string | undefined | null;
  edition2026?: boolean;
}

const DrawCounter = ({
  targetDate,
  bare,
  introText,
  edition2026,
}: DrawCounterProps) => {
  const { paddedTimeLeft, domProps } = useCountdown(targetDate);

  const dayText = 'Days';
  const hourText = edition2026 ? 'Hours' : 'Hrs';
  const minuteText = edition2026 ? 'Minutes' : 'Mins';
  const secondText = edition2026 ? 'Seconds' : 'Secs';

  return (
    <div
      {...domProps}
      className={clsx(
        bare ? undefined : styles.container,
        edition2026 ? styles.edition2026 : '',
      )}
    >
      <span className={` ${styles.nextDraw}`}>
        {introText ?? 'Next draw in'}
      </span>
      <div className={styles.countdown}>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.days}</span>
          <span className={` ${styles.label}`}>{dayText}</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.hours}</span>
          <span className={` ${styles.label}`}>{hourText}</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.minutes}</span>
          <span className={` ${styles.label}`}>{minuteText}</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.seconds}</span>
          <span className={`${styles.label}`}>{secondText}</span>
        </div>
      </div>
    </div>
  );
};

export default DrawCounter;
